import captionService from 'CaptionService';

export const trackingTimeline = {
	noHistory: () =>
		captionService.getString(
			'f1acd6f0-7f57-43c7-9113-5570cd1ee63f',
			'A status update is not yet available'
		),
};
